import AboutTemplate from "../../components/about/AboutTemplate";
import Page from "../Page";
import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Section from "../../components/about/Section";
import ResponsiveImage from "../../components/about/ResponsiveImage";

const ActivityBlocks = () => {
  return (
    <Page className="about-page activity-blocks-page" pageKey="activity-blocks">
      <AboutTemplate>
        <Typography variant="h1">Activity Blocks</Typography>

        <Section>
          <Typography variant="p1">
            Activity blocks let you schedule your{" "}
            <Link
              component={RouterLink}
              to="/about/features/activities"
              variant="p1Link"
            >
              activities
            </Link>{" "}
            into your day plan. They automatically pull in the activity's name,
            emoji, and colour, making your day plan visually clear at a glance.
          </Typography>
          <ResponsiveImage
            pageKey="activityBlocks"
            imageName="activity-block"
            size="large"
          />
        </Section>

        <Section title="Creating an activity block">
          <Typography variant="p1">
            When inserting a new block, select <strong>"Activity Block"</strong>{" "}
            as the block type. You'll see a dropdown of your saved activities -
            pick the one you want to schedule.
          </Typography>
          <Typography variant="p1">
            If you haven't created any activities yet, you'll be prompted to
            create one. You can manage your activities from the{" "}
            <Link
              component={RouterLink}
              to="/about/features/activities"
              variant="p1Link"
            >
              Activities page
            </Link>
            .
          </Typography>
          <ResponsiveImage
            pageKey="activityBlocks"
            imageName="activity-selector"
            size="medium"
          />
        </Section>

        <Section title="Activity duration">
          <Typography variant="p1">
            If your activity has a duration set, the block's end time will
            automatically be calculated based on the start time and the
            activity's duration. This saves you from having to manually set the
            time range every time.
          </Typography>
          <Typography variant="p1">
            You can still adjust the end time manually if needed.
          </Typography>
        </Section>

        <Section title="Editing an activity block">
          <Typography variant="p1">
            Click on an activity block to select it. From the Edit Block panel,
            you can change the linked activity, adjust the time range, or delete
            the block.
          </Typography>
          <ResponsiveImage
            pageKey="activityBlocks"
            imageName="edit-activity-block"
            size="medium"
          />
        </Section>

        <Section title="When to use activity blocks">
          <Typography variant="p1">
            Activity blocks are perfect for recurring, non-task activities that
            you do regularly - things like exercise, meditation, reading, or
            hobbies. By linking them to your activities, your day plan stays
            consistent and recognisable.
          </Typography>
        </Section>
      </AboutTemplate>
    </Page>
  );
};

export default ActivityBlocks;
